import { html, type TemplateResult } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';

/** What makes a toolbar card look like itself. */
const CARD_LOOK = [
  'backgroundColor',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderBottomRightRadius',
  'borderBottomLeftRadius',
  'boxShadow',
  'color',
] as const;

/**
 * A toolbar card as it shows now, for the overlay a drag carries: the overlay lives in the canvas,
 * where the toolbar's styles do not reach, so the card's look is taken from the card itself.
 */
export function draggedCardPreview(
  card: HTMLElement,
  art: TemplateResult
): TemplateResult {
  const look = getComputedStyle(card);
  return html`<div
    style=${styleMap({
      ...Object.fromEntries(CARD_LOOK.map(key => [key, look[key]])),
      border: `${look.borderTopWidth} solid ${look.borderTopColor}`,
      boxSizing: 'border-box',
    })}
  >
    ${art}
  </div>`;
}
